export class PrestayLogin{
  customer_id;
  token: string | null = null;
  reservation_code: string | null = null;
}
